// How far back the server's local mail index (mail_search_index) reaches.
// bot/src/server.js nightlyRetention prunes it at 90 days; search and thread
// view answer from it inside that window, and anything older needs a Graph
// search. Every "older than N days" the dashboard shows comes from here, so
// the wording can't drift from the real retention again (it said 30 for
// months while the index kept 90).
export const LOCAL_INDEX_DAYS = 90;
